// extracted by mini-css-extract-plugin
export var btn = "y_b";
export var header = "y_Q";
export var headerLink = "y_T";
export var headerTitle = "y_S";
export var headerWrap = "y_R";
export var smooth = "y_d";
export var submit = "y_c";